module.exports = "/images/za.svg?5c5a1f1d3caaab18594abd851fa21fb8";